/*
---
description: FED Process
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.3.2: '*'
- more/1.3.2.1: [Utilities.Assets]
...
*/

var UserTools = new Class({
	Implements: [Events, Options],

	options: {
		leave_tools_in_header: true,
		user_tool_hide_delay: 2000
	},

	initialize: function(element, options) {
		this._element = element || document.getElement('.w_stalker');

		if(!this._element) return;

		this.setOptions(options);

		this.build();
	},

	build: function(){
		var self = this;

		this._tools = this.getTools();

		this.setDocumentClick();

		this._tools.each(function(_el){
			if(_el.retrieve('usertools_set'))
				return;

			_el.store('usertools_set', true);

			if (_el.hasClass('user')) {
				self.add_user_support(_el);
			} else if(_el.hasClass('search')){
				self.add_limousine_support(_el);
			} else {
				_el.addEvents({
					'click': function(){
						self.sendRequest(_el);

					}
				});
			}
		});

		this._adaFix();
	},

	_adaFix: function() {
		var ele = this._element;
		var userDropdown = ele.querySelector('.user_menu.dropdown');
		var toggle = ele.querySelector('.tool.user._has_dropdown');
		this.adaHandle = Core.adaUtility.associateToggleAndDropdown(toggle, userDropdown);
	},

	getTools: function(){
		return document.getElements('.w_user_tools .tool');
	},

	sendRequest: function(_el){
		var self = this;

		if(!_el.hasClass('contact'))
		return;

		var rpc = _el.getAttribute('data-rpc');

		if(!rpc || rpc == '')
			return;

		// track
		_gaq.push(['_trackEvent', 'Contact', 'Loaded', 'header']);

		var dataActionFinish = _el.get('data-action');
		var dataLabelFinish = _el.get('data-label') || '';

		new Request.JSON({
			url: rpc,
			onSuccess: function(data){
				var _content = _el.getElement('.rpc_content');

				if(_content){
					_content.set('html', data.content);
					var _encrypted = _content.getElements('.encrypted');
					if(_encrypted && _encrypted.length > 0) {
						_encrypted.each(function(el) {
							Core.add_encrypted_link(el);
						});
					}

					self.blimpForm = new Blimp.Form(null, {
						build: function(blimp_form){
							if(Blimp.Form.instances && Blimp.Form.instances.contains(blimp_form)){
								return;
							}

							blimp_form._element = _content.getElement('.w_popup.email');
							blimp_form.post_process();

							Blimp.Form.instances.include(blimp_form);
						},
						post_process_build: false,
						keep_form_on_success: true,
						show_veil: false,
						auto_hide_form: false,
						'onSuccessHide' : function(){
							_el.removeClass('_active');
							ActiveUserTool = null;
							self.adaHandle && self.adaHandle.onClose();
						},
						action: dataActionFinish,
						label: dataLabelFinish
					});
				}
			}
		}).send();

		_el.removeEvents('click');
	},

	submit: function(ev) {
		if (ev) {
			ev.stopPropagation();
			ev.preventDefault();
		}

		var self = this;
		window.crRecaptcha.execute(function(){ self.blimpForm.handle_form_submit()});

		// remove click callback
		this.blimpForm._element.getElement('.button').removeEvents('click');
	},

	setDocumentClick: function(){
		var self = this;
		if (!document.retrieve('usertools_set')) {
			document.store('usertools_set', true);
			document.addEvents({
				'click:relay(*)': function(e, _el){
					var _tool = self.get_click_tool(_el);

					if (_tool) {
						document.fireEvent('hideSubMenu');
					}

					if(self.is_on_tool(_el) || e.rightClick ) return;

					if(!_tool && ActiveUserTool){
						ActiveUserTool.removeClass('_active');
						self.adaHandle && self.adaHandle.onClose();
						ActiveUserTool = null;
					}else if(_tool && ActiveUserTool && _tool !== ActiveUserTool){
						ActiveUserTool.removeClass('_active');
						_tool.addClass('_active');
						ActiveUserTool = _tool;
						self.adaHandle && self.adaHandle.onOpen();
					}else if(_tool && ActiveUserTool && _tool === ActiveUserTool){
						_tool.removeClass('_active');
						self.adaHandle && self.adaHandle.onClose();
						ActiveUserTool = null;
					}else if(_tool && !ActiveUserTool){
						// track
						var action = _tool.getAttribute('data-action');
						_gaq.push(['_trackEvent', window.pageType, action, 'Contact Start']);
						_tool.addClass('_active');
						self.adaHandle && self.adaHandle.onOpen();
						ActiveUserTool = _tool;
					}

					if (ActiveUserTool && ActiveUserTool.hasClass('search') && ActiveUserTool.limo) {
						ActiveUserTool.limo._field.focus();
					}

					// remove members notification when the user clicks the user tool
					if (ActiveUserTool && ActiveUserTool.hasClass('user')) {
						self.remove_members_notification();
					}
				}
			});
		}
	},

	get_click_tool: function(_el){
		return (_el.hasClass('tool') && _el.hasClass('_has_dropdown') && _el.getParent('.w_user_tools')) ? _el : _el.getParent('.tool._has_dropdown');
	},

	is_on_tool: function(_el){
		return (_el.getParent('.dropdown') && _el.getParent('.tool') && _el.getParent('.w_user_tools'));
	},

	add_limousine_support: function(_el){
		if(_el.limo) return;

		var _limo  = _el.getElement('.w_limousine');

		if(_limo){
			_el.limo = new LimousineAnything(_limo, {
				min_chars: 3,
				submit_onenter: false,
				cache: true,
				form_action: _limo.getAttribute('data-rpc'),
				textfield_selector: '.w_limousine_autocomplete._front'
			});

			if(!_el.hasClass('_has_dropdown')){
				_el.limo.addEvents({
					'textfieldFocus': function(){
						_limo.addClass('_stretch');
						document.fireEvent('hideSubMenu');
					},

					'textfieldBlur': function(){
						(function(){
							_limo.removeClass('_stretch');
						}).delay(500);
					}
				});

				_limo.addEvents({
					'click': function(){
						_limo.addClass('_stretch');
						_el.limo._field.focus();
					}
				});
			}
		}else{
			_el.limo = 'no limo';
		}

		if((_el.limo._field && !_el.limo._field.getProperty('placeholder')) || Core.is_ie()){
			new TextOver(_el.limo._field);
		}
	},

	add_user_support: function(_el) {
		var self = this;
		var _members_notification = _el.getElement('.members_center_notification');

		if (_members_notification) {
			if (Cookie.read('crSignup')) {
				_members_notification.show();
			}
			_members_notification.addEvent('click', function(ev) {
				if (!ev.target.hasClass('button')) {
					if (ev && ev.stop) ev.stop();
				} else {
					setTimeout(function() {
						if (_el.hasClass('_active')) {
							var _menu = _el.getElement('.dropdown.user_menu');
							if(_menu){
								var fx = new Fx.Tween(_menu, {
								    duration: 300,
								    property: 'opacity'
								});
								fx.start(1, 0).chain(function(){
									_el.removeClass('_active');
									ActiveUserTool = null;
									_menu.setStyle('opacity', 1);
									self.adaHandle && self.adaHandle.onClose();
								});
							}
						}
					}, self.options.user_tool_hide_delay);

				}
			});
		}
	},

	remove_members_notification: function() {
		// Clean signup cookie (to display the notif)
		Cookie.dispose('crSignup');

		var _members_notifications = document.getElements('.members_center_notification');
		if (_members_notifications.length > 0) {
			//remove all member's notification
			_members_notifications.each(function(_el){
				_el.destroy();
			});
		}
	}
});

UserTools.extend({
	update: function() {
		new UserTools();
	}
});

var ActiveUserTool = null;
